import Vue from 'vue'
import Router from 'vue-router'
// import API from '@/api/callApi.js'
// import endpoints from '@/api/endpoints';

import App from '@/views/app/index.vue'

// import Dashboard from '@/views/dashboard/index.vue'
import DashboardV2 from '@/views/dashboard-v2/index.vue'

import Workflows from '@/views/workflows/index.vue'

import PublicWrapper from '@/views/public-portal/index.vue'

import Customers from '@/views/customers/index.vue'
import CustomersOverview from '@/views/customers/overview/index.vue'
import CustomersDatabase from '@/views/customers/database/index.vue'
import CustomersArchives from '@/views/customers/archives/index.vue'

import ProfilSettings from '@/views/profil/settings/index.vue'

import ProfilShops from '@/views/profil/shops/index.vue'

import ProfilRouters from '@/views/profil/routers/index.vue'

import Portal from '@/views/portal/index.vue'

import PublicPortal from '@/views/portal/public-portal.vue'

import PublicPortalMenu from '@/views/portal/pdf-menu-viewer.vue'

// import Notifications from '@/views/notifications/index.vue'

// import Statistics from '@/views/statistics/index.vue'

import Profil from '@/views/profil/index.vue'

import CreateWorkflow from '@/views/workflows/create/index.vue'

import ManageWorkflow from '@/views/workflows/manage/index.vue'

import EnableWorkflow from '@/views/workflows/enable/index.vue'

import Password from '@/views/auth/password.vue'

import Login from '@/views/auth/login.vue'

import PasswordLink from '@/views/auth/passwordLink.vue'

import PasswordReset from '@/views/auth/passwordReset.vue'

import Auth from '@/views/auth/index.vue'

import DeviceDetection from '@/views/auth/devicedetection.vue'

import CheckDevice from '@/utils/checkDevice.js'

import Message from '@/views/message/index.vue'

/**
 * Segment
 */
import Segments from '@/views/segment/index.vue'
import ListSegments from '@/views/segment/list/index.vue'
import CreateSegment from '@/views/segment/create/index.vue'
import EditSegment from '@/views/segment/edit/index.vue'
import ShowSegment from '@/views/segment/show/index.vue'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path : '/mobile',
            name : 'DeviceDetection',
            component : DeviceDetection
        },
        {
            path : '/public',
            name : 'Public',
            component : PublicWrapper,
            redirect : '/public/portal',
            children : [
                {
                    name : 'PublicPortal',
                    path : 'portal/:establishment_id?',
                    component : PublicPortal
                },
                {
                    name : 'PublicPortalMenu',
                    path : 'portal/menu/:establishment_id?',
                    component : PublicPortalMenu
                }
            ]
        },
        {
            path: '/auth',
            name: 'Auth',
            component: Auth,
            redirect: '/auth/login',
            beforeEnter: (to, from, next) => {

                // console.info(navigator.userAgent,navigator.vendor);

                if (CheckDevice() === 'mobile') {
                    return next({ name : 'DeviceDetection'});
                } 

                const homeRoute = {name : 'DashboardV2'};
                const userCookie = window.$cookies.isKey(process.env.VUE_APP_COOKIE_NAME); 
                if(!userCookie){
                    return next();
                }
                else {
                    return next(homeRoute);
                }
            },
            children : [
                {
                    path : 'login',
                    name : 'Login',
                    component : Login
                },
                {
                    path : 'password',
                    name : 'Password',
                    component : Password
                },
                {
                    path : 'password/reset/confirm/:email',
                    name : 'PasswordResetConfirm',
                    component : PasswordLink
                },
                {
                    path : 'password/reset/:email',
                    name : 'PasswordReset',
                    component : PasswordReset
                }
            ],
        },    
        {
            path: '/app',
            name: 'AppContainer',
            component: App,
            redirect: '/app/dashboardv2',
            beforeEnter: (to, from, next) => {
                if (CheckDevice() === 'mobile') {
                    return next({ name : 'DeviceDetection'});
                }
                const loginRoute = { name : 'Login'};
                const userCookie = window.$cookies.isKey(process.env.VUE_APP_COOKIE_NAME); 
                if(!userCookie){
                    return next(loginRoute);
                }
                else {
                    return next();
                }
            },
            children : [
                // {
                //     path : '/dashboard',
                //     name : 'Dashboard',
                //     component : Dashboard
                // },
                {
                    path : 'dashboardv2',
                    name : 'DashboardV2',
                    component : DashboardV2
                },
                {
                    path : 'workflows',
                    name : 'Workflows',
                    component : Workflows,
                    redirect : 'workflows/manage',
                    children : [
                        {
                            path : 'create',
                            name : 'CreateWorkflow',
                            component : CreateWorkflow
                        },
                        {
                            path : 'manage',
                            name : 'ManageWorkflow',
                            component : ManageWorkflow
                        },
                        {
                            path : 'enable',
                            name : 'EnableWorkflow',
                            component : EnableWorkflow
                        },
                        {
                            path: 'message',
                            name: 'Message',
                            component: Message,
                        }, 
                    ]
                },
                {
                    path : 'customers',
                    name : 'Customers',
                    component : Customers,
                    redirect : 'customers/overview',
                        children : [
                            {
                                path : 'overview',
                                name : 'CustomersOverview',
                                component : CustomersOverview
                            },
                            {
                                path : 'database',
                                name : 'CustomersDatabase',
                                component : CustomersDatabase
                            },
                            {
                                path : 'archives',
                                name : 'CustomersArchives',
                                component : CustomersArchives
                            }
                        ]
                },
                {
                    path : 'portal',
                    name : 'Portal',
                    component : Portal,
                },
                // {
                //     path : '/notifications',
                //     name : 'Notifications',
                //     component : Notifications
                // },
                // {
                //     path : '/statistics',
                //     name : 'Statistics',
                //     component : Statistics
                // },
                {
                    path : 'profil',
                    name : 'Profil',
                    component : Profil,
                    redirect : 'profil/settings',
                    children : [
                        {
                            path : 'settings',
                            name : 'ProfilSettings',
                            component : ProfilSettings
                        },
                        {
                            path : 'shops',
                            name : 'ProfilShops',
                            component : ProfilShops
                        },
                        {
                            path : 'routers',
                            name : 'ProfilRouters',
                            component : ProfilRouters
                        }
                    ]
                },
                {
                    path : 'segments',
                    name : 'Segments',
                    component : Segments,
                    redirect : 'segments/list',
                    children : [
                        {
                            path : 'list',
                            name : 'ListSegments',
                            component : ListSegments
                        },
                        {
                            path : 'create',
                            name : 'CreateSegment',
                            component : CreateSegment
                        },
                        {
                            path : ':segment/show',
                            name : 'ShowSegment',
                            component : ShowSegment
                        },
                        {
                            path : ':segment/edit',
                            name : 'EditSegment',
                            component : EditSegment
                        },
                    ]
                },
            ]
        },
        {
            path : '/',
            name : 'ROOT',
            beforeEnter: (to, from, next) => {

                if (CheckDevice() === 'mobile') {
                    return next({ name : 'DeviceDetection'});
                }

                const isLoggedIn = window.$cookies.isKey(process.env.VUE_APP_COOKIE_NAME);

                if(!isLoggedIn){
                    return next({ name : 'Auth' });
                }
                else {
                    return next({name : 'DashboardV2'});
                }

            }
        }
    ]
})
